
import { validationMixin } from "vuelidate";
import { SistemaMixin } from "@/modules/Application";
import NaturezaData, { NaturezaDataRequired } from "./NaturezaData";
import VueSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import _ from "lodash";

export default {
  name: "app-natureza-form",
  props: {
    url: {
      type: String,
    },
    natureza: {
      type: Object,
      default: () => {},
    },
  },
  mixins: [validationMixin, SistemaMixin],
  data() {
    return {
      tabIndex: 0,
      form: {},
      cfops: [],
      tributacoes: [],
    };
  },
  validations: {
    form: NaturezaDataRequired,
  },
  components: {
    VueSelect,
  },
  mounted() {
    this.getDataInit();
  },
  methods: {
    async getDataInit() {
      this.form = new NaturezaData({});

      if (this.natureza.id) {
        this.form = this.natureza;
      }
      this.getTributacao().then((data) => (this.tributacoes = data));
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    validateTributacao(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    onSearchCFOP(search, loading) {
      if (search.length) {
        loading(true);
        this.searchCFOP(loading, search, this);
      }
    },
    searchCFOP: _.debounce(async (loading, search, vm) => {
      vm.cfops = await vm.getCFOPByCodigo(search);
      loading(false);
    }, 350),
    onSearchTributacao(search, loading) {
      if (search.length) {
        loading(true);
        this.onTributacao(loading, search, this);
      }
    },
    onTributacao: _.debounce(async (loading, search, vm) => {
      vm.tributacoes = await vm.getTributacaoByDescricao(search);
      loading(false);
    }, 350),
    setMovimentaEstoque() {
      this.form.movimentaEstoque = this.form.movimentaEstoque ? false : true;
    },
    setCalculaIPI() {
      this.form.calculaIpi = this.form.calculaIpi ? false : true;
    },
    setRetencaoPISCOFINS() {
      this.form.retencaoPISCOFINSCSLL = this.form.retencaoPISCOFINSCSLL
        ? false
        : true;
    },
    setCalcularTributo() {
      this.form.calculaTributo = this.form.calculaTributo ? false : true;
    },
    async onSubmit() {
      const submitButton = this.$refs["submit_nova_natureza"];

      if (this.form.cfop.length <= 0) {
        return this.$toast.error("Selecione um CFOP!");
      }

      if (this.form.tributacao.length <= 0) {
        return this.$toast.error("Selecione uma tributação!");
      }

      try {
        this.$v.form.$touch();

        if (this.$v.form.$anyError) {
          return;
        }

        submitButton.classList.add("spinner", "spinner-light", "spinner-right");
        submitButton.setAttribute("disabled", "");

        await this.$http.post(this.url, this.form);

        this.$router.push({ name: "naturezasLista" });
      } catch (error) {
        submitButton.classList.remove(
          "spinner",
          "spinner-light",
          "spinner-right"
        );
        submitButton.removeAttribute("disabled", "");
      }
    },
  },
};
